"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = void 0;
const deepmerge_1 = __importDefault(require("deepmerge"));
exports.merge = deepmerge_1.default;
//# sourceMappingURL=merge.js.map